<template>
	<div v-editable="blok" class="md:flex md:items-start md:gap-12 lg:gap-8 mb-6">
		<div class="md:basis-1/2 lg:basis-[auto] lg:flex-1 mb-6 md:mb-0 px-4 md:px-6 lg:px-8">
			<span
				class="size-8 bg-icon-primary text-body-inverse inline-flex mb-2 md:mb-4 rounded-full items-center justify-center typo-body-l font-bold"
			>
				{{ computerToHumanIndexing(index) }}
			</span>
			<RichText :data="blok.description" class="typo-body-s max-w-[100ch]" />
		</div>
		<div
			v-if="images.length"
			class="rounded-md overflow-hidden sticky top-0 grid grid-flow-col auto-cols-fr md:basis-1/2 lg:basis-[auto] lg:shrink-0 lg:rem:w-[500px]"
		>
			<NuxtPicture
				v-for="(image, imageIndex) in images"
				:key="imageIndex"
				provider="storyblok"
				:modifiers="image.focus ? {filters: {focal: image.focus}} : {}"
				:src="image.filename"
				:alt="image.alt || ''"
				:sizes="
					images.length > 1
						? 'xs:50vw sm:50vw md:50vw inf:500px'
						: 'xs:100vw sm:100vw md:100vw inf:500px'
				"
				:img-attrs="{
					class: [
						'w-full',
						images.length === 1 && blok.imagePreserveAspectRatio ? '' : 'object-cover h-60',
					],
				}"
				loading="lazy"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
	import {compact, filter} from 'lodash-es';
	import type {StepsListStoryblok} from '@/storyblok/types';

	interface Props {
		blok: StepsListStoryblok
		index: number
	}

	const props = defineProps<Props>();

	const images = computed(() => compact(filter([props.blok.image1, props.blok.image2], 'filename')));
</script>
